import React, { useEffect, useState, useRef } from 'react';
import { Tabs } from 'antd-mobile';
import VehicleList from '../MultiVehicle';
import OrderListAndCreateTask from '@/jkc/OrderListAndCreateTask';
import { commonFetchApi } from '@/fetch/business/common';
import AirGroundApi from '@/fetch/business/airGround';
import { HttpStatusCode } from '@/fetch/core/constant';
import { useTaskInfoStore } from '@/jkc/store';
import { qidianLog } from '@/utils';
import Cookie from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'workbench_active_tab';

const TAB_KEYS = {
  PICKUP: 'pickup-task',
  CONNECT: 'connect',
  JKC: 'call-car-pickup-goods'
};

let hasInitCsat = false;
let csatInitPromise: Promise<void> | null = null;

const NewInfo = () => {
  const { resetTaskInfo } = useTaskInfoStore();
  const airGroundApiRef = useRef<AirGroundApi>(new AirGroundApi());
  const navigator = useNavigate();
  const [activeKey, setActiveKey] = useState(TAB_KEYS.CONNECT);
  const [showJKC, setShowJKC] = useState(false);
  const [showPickup, setShowPickup] = useState(false);
  const [isWorkbenchReady, setIsWorkbenchReady] = useState(false);
  const [componentKeys, setComponentKeys] = useState({
    [TAB_KEYS.PICKUP]: Date.now(),
    [TAB_KEYS.CONNECT]: Date.now(),
    [TAB_KEYS.JKC]: Date.now()
  });

  useEffect(() => {
    const init = async () => {
      let jkcEnabled = false;
      let pickupEnabled = false;
      try {
        const res = await commonFetchApi.checkEnableJKC();
        if (res.code === HttpStatusCode.Success && res.data) {
          jkcEnabled = res.data.enableJkc;
        }
      } catch (error) {
        console.error('Failed to check JKC availability:', error);
      }

      try {
        const res = await airGroundApiRef.current.checkSite();
        if (res.code === HttpStatusCode.Success) {
          pickupEnabled = res.data === true;
        }
      } catch (error) {
        console.error('Failed to check pickup availability:', error);
      }

      setShowJKC(jkcEnabled);
      setShowPickup(pickupEnabled);

      localStorage.removeItem('vehicleName');
      const savedKey = localStorage.getItem(STORAGE_KEY);

      if (savedKey === TAB_KEYS.PICKUP && pickupEnabled) {
        setActiveKey(TAB_KEYS.PICKUP);
      } else if (savedKey === TAB_KEYS.JKC && jkcEnabled) {
        setActiveKey(TAB_KEYS.JKC);
      } else if (savedKey === TAB_KEYS.CONNECT) {
        setActiveKey(TAB_KEYS.CONNECT);
      } else if (pickupEnabled) {
        setActiveKey(TAB_KEYS.PICKUP);
      } else {
        setActiveKey(TAB_KEYS.CONNECT);
      }

      setIsWorkbenchReady(true);
    };

    init();
  }, []);

  const handleTabChange = (key: string) => {
    setActiveKey(key);
    localStorage.setItem(STORAGE_KEY, key);
    resetTaskInfo();
    setComponentKeys((keys) => ({ ...keys, [key]: Date.now() }));
    key === TAB_KEYS.CONNECT &&
      qidianLog('transport_workbench|clickDocking', {});
    key === TAB_KEYS.JKC &&
      qidianLog('transport_workbench|clickHailingCargoTab', {});
  };

  const renderVehicleList = () => (
    <VehicleList
      key={componentKeys[TAB_KEYS.CONNECT]}
      enableCsat={
        isWorkbenchReady && (!showTabs || activeKey === TAB_KEYS.CONNECT)
      }
    />
  );

  useEffect(() => {
    if ((window as any).__JD_CSAT) {
      hasInitCsat = true;
      return;
    }
    if (hasInitCsat || csatInitPromise) {
      return;
    }

    hasInitCsat = true;
    csatInitPromise = (window as any)
      .JD_CSAT({
        id: 'root',
        prefix: process.env.JDX_APP_LOP_DOMAIN!,
        systemCode: 'WRCGJ',
        userType: 1,
        routerType: 'history',
        language: 'zh_CN',
        headers: {
          'Lop-Dn': 'common.outer.csat.jdl.com',
          pin: Cookie.get('pin') || ''
        }
      })
      .then((instance: any) => {
        (window as any).__JD_CSAT = instance;
      })
      .catch((error: any) => {
        hasInitCsat = false;
        console.error('初始化CSAT失败', error);
      })
      .finally(() => {
        csatInitPromise = null;
      });
  }, []);

  const renderPickupVehicleList = () => (
    <VehicleList
      key={componentKeys[TAB_KEYS.PICKUP]}
      title="无人站车辆"
      hideMileage={true}
      enableCsat={false}
      fetchVehicleList={() => airGroundApiRef.current.getVehicleList()}
      onVehicleClick={(vehicle) => {
        if (vehicle?.vehicleName) {
          navigator(
            `/air-ground/singleVehicle?vehicleName=${vehicle.vehicleName}`
          );
        }
      }}
    />
  );

  const showTabs = showJKC || showPickup;

  return (
    <div className="workbench-container">
      {showTabs ? (
        <Tabs activeKey={activeKey} onChange={handleTabChange}>
          {showPickup && (
            <Tabs.Tab title="取货任务" key={TAB_KEYS.PICKUP}>
              {activeKey === TAB_KEYS.PICKUP ? renderPickupVehicleList() : null}
            </Tabs.Tab>
          )}
          <Tabs.Tab title="接驳" key={TAB_KEYS.CONNECT}>
            {renderVehicleList()}
          </Tabs.Tab>

          {showJKC && (
            <Tabs.Tab title="叫车拉货" key={TAB_KEYS.JKC}>
              <OrderListAndCreateTask key={componentKeys[TAB_KEYS.JKC]} />
            </Tabs.Tab>
          )}
        </Tabs>
      ) : (
        <div style={{ padding: '12px' }}>{renderVehicleList()}</div>
      )}
    </div>
  );
};

export default NewInfo;
